import { WithDirection } from '@jjj/components';
import styled from 'styled-components';

export const ModalBodyWrapper = WithDirection(styled.div`
  padding: 0 65px;
`);

export const Description = WithDirection(styled.p`
  text-align: center;
  margin-bottom: 37px;
`);
